export default function Support() {
  const faqs = [
    {
      question: 'How does BRIMA VPN protect my privacy?',
      answer: 'BRIMA VPN uses military-grade AES-256 encryption to secure all your internet traffic. We maintain a strict zero-log policy, meaning we never track, record, or store your online activities, browsing history, or connection logs.'
    },
    {
      question: 'Can I use BRIMA VPN on multiple devices?',
      answer: 'Yes, you can use BRIMA VPN on multiple devices simultaneously. Our service supports all major platforms including Windows, macOS, iOS, Android, and Linux, allowing you to protect all your devices with a single account.'
    },
    {
      question: 'Will using a VPN slow down my internet speed?',
      answer: 'BRIMA VPN is optimized for speed with our global network of high-performance servers. While encryption adds minimal overhead, most users experience negligible speed differences, and in some cases, speeds may even improve by bypassing ISP throttling.'
    },
    {
      question: 'What is your refund policy?',
      answer: 'We offer a 30-day money-back guarantee. If you\'re not completely satisfied with our service within the first 30 days, contact our support team for a full refund, no questions asked.'
    },
    {
      question: 'How do I get technical support?',
      answer: 'Our support team is available 24/7 via email, live chat, and phone. You can reach us through the contact form below, or email us directly at info@brimaservicosdecobrancaltda.com for immediate assistance.'
    },
    {
      question: 'Is BRIMA VPN legal to use?',
      answer: 'Yes, using a VPN is legal in most countries. BRIMA VPN is a legitimate privacy tool designed to protect your online security and freedom. However, we encourage users to comply with local laws and regulations in their jurisdiction.'
    }
  ];

  return (
    <section id="support" className="py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-20">
          <div className="text-gray-500 text-xs font-medium tracking-[3px] uppercase mb-6">
            Support Center
          </div>
          <h2 className="text-[#0D1B2A] text-[80px] font-extrabold leading-[1.1] tracking-tight mb-6">
            FREQUENTLY ASKED
            <br />
            QUESTIONS
          </h2>
          <p className="text-[#5F6C7B] text-xl max-w-[700px] mx-auto">
            Find answers to common questions about our VPN service, security features, and technical support
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-[#F8FAFB] rounded-2xl overflow-hidden border border-gray-200 hover:border-[#00D9FF] transition-all duration-300"
            >
              <summary className="flex items-center justify-between px-8 py-6 cursor-pointer list-none">
                <h3 className="text-[#0D1B2A] text-xl font-semibold pr-8">
                  {faq.question}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-add-line text-2xl text-[#0D1B2A] group-open:hidden"></i>
                  <i className="ri-subtract-line text-2xl text-[#00D9FF] hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-8 pb-6">
                <p className="text-[#5F6C7B] text-base leading-[1.7]">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-[#5F6C7B] text-lg mb-6">
            Still have questions? Our support team is here to help.
          </p>
          <a
            href="#contact"
            className="inline-block px-10 py-4 bg-[#00D9FF] text-white font-semibold rounded-full hover:bg-[#00C4E6] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Contact Support
          </a>
        </div>
      </div>
    </section>
  );
}
